<template>
  <b-container>
    <b-card title="Planning voor de komende 4 weken">
      <calendar-view
        id="calendar"
        :events="planningItems"
        :class="themeClasses"
        :display-period-uom="calenderOptions.displayPeriod" 
        :disable-past="true"
        :disable-future="true"
        :starting-day-of-week="1" 
        :display-period-count="calenderOptions.displayPeriodCount"
      />
      <b-table 
        :fields="['titel','Datum','Omschrijving','Status','Bijlagen']" 
        :items="planningItems"
      />
    </b-card>
  </b-container>
</template>
<script>
import CalendarView from "vue-simple-calendar"
import "vue-simple-calendar/dist/static/css/default.css"
import "vue-simple-calendar/dist/static/css/holidays-us.css"
import { serviceMixin } from "@/mixins/serviceMixin";

export default {
  name: 'TabPlanning',
  components: {
    CalendarView
  },
  mixins: [serviceMixin],
  props: {
    unit: {
      type: Object,
      default: null
    }
  },
  data() {
      return  {
        calenderOptions: {
          displayPeriod: 'week',
          displayPeriodCount: 4,
          useDefaultTheme: true,
          useHolidayTheme: true,
        },
        planning: [],
      }
  },
  computed: {
    themeClasses() {
        return {
          "theme-default": this.calenderOptions.useDefaultTheme,
          "holiday-us-traditional": this.calenderOptions.useHolidayTheme,
          "holiday-us-official": this.calenderOptions.useHolidayTheme,
        }
      },
      planningItems () {
        return this.planning
      }
  },
  watch: {},
  mounted () {
          this.getPlanning();
  },
  methods: {
    getPlanning() {
      this.get(`/unit/${this.unit.Id}/planning`).then((resp) => {
        this.planning = resp.data.events
        console.log(resp.data)
      }).finally(() => {  });
    },
  },
        
}
</script>
<style lang="scss">
  @import '../../assets/scss/style';
  #calendar {
    color: $body-color;
    height: 35vh;
    margin-left: auto;
    margin-right: auto;
  }
  .theme-default .cv-event {
    background-color: $secondary;
    border-color: $table-border-color;
    color: $body-color;
  }
  .theme-default .cv-event.success {
    background-color: $success;
    border-color: lighten($success, 5%);
  }
  .theme-default .cv-event.danger {
    background-color: $danger;
  }
  .theme-default .cv-event.primary {
    background-color: $primary;
  }
  .theme-default .cv-event.orange {
    background-color: $orange;
    border-color: lighten($orange, 5%);
  }
  .theme-default .cv-day.today {
    background-color: $gray-300;
  }
  .theme-default .cv-day.today > .cv-day-number {
    background-color: $blue;
    border-radius: 50%;
  }
  .theme-default .cv-day.past {
     background-color: $body-bg;
  }
  .theme-default .cv-day.outsideOfMonth {
     background-color: $body-bg;
  }
  .theme-default .cv-weeks,
  .theme-default .cv-day {
    border-color: $table-border-color;
  }
  .theme-default .cv-header,
  .theme-default .cv-header-days,
  .theme-default .cv-header-day {
    background-color: $table-head-bg;
    border-color: $table-border-color;
  }
  .theme-default .cv-header-nav > button {
    color: $body-color;
    background-color: $input-bg;
    border-color: $input-border-color;
  }
  .theme-default .cv-day.draghover {
    box-shadow: inset 0 0 0.2em 0.2em $sidebar-nav-link-hover-bg;
  }
</style>